import type { SVGProps } from "react";

const IconHamburger = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="1em"
      height="1em"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.770107 1.4923H14.2299C14.6559 1.4923 15 1.15809 15 0.74615C15 0.334407 14.6561 0 14.2299 0H0.770107C0.344917 0 0 0.334213 0 0.74615C0 1.15809 0.344917 1.4923 0.770107 1.4923ZM14.2297 5.22305H0.770107C0.343941 5.22305 0 5.55726 0 5.9692C0 6.38114 0.343941 6.71535 0.770107 6.71535H14.2299C14.6559 6.71535 15 6.38114 15 5.9692C14.9998 5.55726 14.6537 5.22305 14.2297 5.22305ZM14.2297 10.5077H0.770107C0.345113 10.5077 0 10.8419 0 11.2538C0 11.6658 0.344917 12 0.770107 12H14.2299C14.6559 12 15 11.6658 15 11.2538C14.9998 10.8421 14.6559 10.5077 14.2297 10.5077Z"
        fill="#667D98"
      />
    </svg>
  );
};

export default IconHamburger;
